<script setup lang="ts">
import 'vue-sonner/style.css'
import AccessDeniedDialog from '~/components/layout/AccessDeniedDialog.vue'
import { Toaster } from '~/components/ui/sonner'

const { isOpen, close } = useAccessDeniedModal()

const siteName = 'YourService Business'

useHead({
    titleTemplate: (title) => title ? `${title} · ${siteName}` : siteName,
})
</script>

<template>
    <NuxtRouteAnnouncer />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
    <Toaster position="bottom-right" />
    <AccessDeniedDialog
        :open="isOpen"
        @close="close"
    />
</template>
